<h1 mat-dialog-title>Pressão Arterial</h1>
<div mat-dialog-content>
  <div class="modal-body text-center">
    <form class="form" [formGroup]="model" (ngSubmit)="submit()" [appUppercaseForm]="this.setUppercaseText">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-6">
          <mat-form-field appearance="outline">
            <mat-label>Sistólica</mat-label>
            <input [value]="data.discriminatorsValues[this.discriminatorType] ? data.discriminatorsValues[this.discriminatorType].split('/')[0] : null" [mask]="masks.threeDigits" type="text" matInput formControlName="systolic">
            <span matSuffix>mmHg</span>
          </mat-form-field>
        </div>
        <div class="col-12 col-sm-12 col-md-6">
          <mat-form-field appearance="outline">
            <mat-label>Diastólica</mat-label>
            <input [value]="data.discriminatorsValues[this.discriminatorType] ? data.discriminatorsValues[this.discriminatorType].split('/')[1] : null" [mask]="masks.threeDigits" type="text" matInput formControlName="diastolic">
            <span matSuffix>mmHg</span>
          </mat-form-field>
        </div>
      </div>
      @if (data.classificationData && data.classificationData.priorityAutistic && !data.discriminatorsValues[this.discriminatorType]) {
        <div
          class="row">
          <div class="col-12">
            <mat-slide-toggle class="priorityAutistic" (change)="changePriorityAutistic($event)"
              formControlName="priorityAutistic">
              Não é possível aferir
            </mat-slide-toggle>
          </div>
          @if (autisticChecked) {
            <div class="col-12">
              <mat-form-field appearance="outline">
                <mat-label>Motivo</mat-label>
                <textarea type="text" matInput formControlName="discriminatorSelectionMotive"></textarea>
              </mat-form-field>
            </div>
          }
        </div>
      }
      <div class="footer-panel-modal-list">
        <div class="row">
          <div class="col-12">
            <button type="submit" mat-flat-button color="primary" class="btn-block">Concluir</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>